import React from "react";
import { Link } from "react-router-dom";
import ArrowForward from "@material-ui/icons/ArrowForwardIos";
import CalendarHomeContainer from "../../containers/CalendarHomeContainer/CalendarHomeContainer";
import { ContentCalendarEvent } from "./CalendarEvent.styled";
import PropTypes from "prop-types";

const CalendarEvent = ({ isAgent }) => {
  return (
    <ContentCalendarEvent>
      <p className="calendar-event_title">
        <Link to="/MyCalendar">
          My Calendar
          <ArrowForward />
        </Link>
      </p>
      <CalendarHomeContainer isAgent={isAgent} />
    </ContentCalendarEvent>
  );
};

export default CalendarEvent;

CalendarEvent.propTypes = {
  isAgent: PropTypes.bool,
};
